import { render, staticRenderFns } from "./DetailBody.vue?vue&type=template&id=c8129692&scoped=true&"
import script from "./DetailBody.vue?vue&type=script&lang=js&"
export * from "./DetailBody.vue?vue&type=script&lang=js&"
import style0 from "./DetailBody.vue?vue&type=style&index=0&id=c8129692&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8129692",
  null
  
)

export default component.exports